import src from "IMAGE";
export default { src, width: 628, height: 115, blurWidth: 0, blurHeight: 0};
